import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useDarkMode } from '../context/DarkModeContext';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const { darkMode } = useDarkMode();
  const navigate = useNavigate();

  return (
    <Box
      component="footer"
      className={darkMode ? 'dark-theme' : ''}
      sx={{
        mt: 'auto',
        py: 3,
        px: 2,
        textAlign: 'center',
        borderTop: `1px solid ${darkMode ? '#333' : '#e0e0e0'}`,
        backgroundColor: darkMode ? '#1a1a1a' : '#f5f5f5',
        color: darkMode ? '#81c784' : '#388e3c',
        fontSize: '0.9rem',
        fontWeight: 500
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: 'inherit',
          fontSize: 'inherit',
          fontWeight: 'inherit'
        }}
      >
        © 2025{' '}
        <Link
          href="https://text-json.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: 'inherit',
            textDecoration: 'none',
            fontWeight: 'bold',
            '&:hover': {
              textDecoration: 'underline',
              color: darkMode ? '#66bb6a' : '#2e7d32'
            }
          }}
        >
          text-json.com
        </Link>
        {' | '}
        <Link
          href="mailto:contact@text-json.com"
          sx={{
            color: 'inherit',
            textDecoration: 'none',
            fontWeight: 'bold',
            '&:hover': {
              textDecoration: 'underline',
              color: darkMode ? '#66bb6a' : '#2e7d32'
            }
          }}
        >
          Contact Us
        </Link>
        {' | '}
        <Link
          component="button"
          onClick={() => navigate('/faqs')}
          sx={{
            color: 'inherit',
            textDecoration: 'none',
            fontWeight: 'bold',
            '&:hover': {
              textDecoration: 'underline',
              color: darkMode ? '#66bb6a' : '#2e7d32'
            }
          }}
        >
          FAQs
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer; 